import { Action } from '../../types/action.js';
import { RecoSettingsPrioritisationGoal } from '../../types/Recommendations.js';
import { recommendationsActionsGoal } from '../action/api/RecommendationsApi.js';

const initialState: RecoSettingsPrioritisationGoal = {
  isLoading: false,
  error: '',
  prioritisationGoal: null,
};

const reducer = (
  state: RecoSettingsPrioritisationGoal = initialState,
  action: Action<RecoSettingsPrioritisationGoal>,
) => {
  switch (action.type) {
    case recommendationsActionsGoal.type.REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }

    case recommendationsActionsGoal.type.FAILED: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    case recommendationsActionsGoal.type.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: '',
        ...action.payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
